import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './OwnerPortalPage.css';

const initialForm = {
  username: '',
  password: '',
  name: '',
  email: '',
  phone: '',
  aircraft_registration: '',
  aircraft_type: '',
  base_airport: ''
};

export default function OwnerRegisterPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (!form.username.trim() || !form.password || !form.name.trim() || !form.email.trim()) {
      setError(t('ownerRegister.errAccountRequired'));
      return;
    }
    if (form.password.length < 6) {
      setError(t('ownerRegister.errPasswordLength'));
      return;
    }
    if (!form.aircraft_registration.trim() || !form.aircraft_type.trim() || !form.base_airport.trim()) {
      setError(t('ownerRegister.errAircraftRequired'));
      return;
    }

    setSaving(true);
    try {
      const { data } = await axios.post('/api/auth/register-owner', {
        ...form,
        username: form.username.trim(),
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        aircraft_registration: form.aircraft_registration.trim().toUpperCase(),
        aircraft_type: form.aircraft_type.trim(),
        base_airport: form.base_airport.trim().toUpperCase()
      });
      setSuccess(data.message || t('ownerRegister.success'));
      setForm(initialForm);
    } catch (err) {
      setError(err.response?.data?.error || t('ownerRegister.errGeneric'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="owner-page owner-login-page">
      <section className="owner-auth-card owner-register-card">
        <p className="owner-eyebrow">{t('ownerRegister.eyebrow')}</p>
        <h1>{t('ownerRegister.title')}</h1>
        <p className="owner-muted">
          {t('ownerRegister.intro')}
        </p>

        {error && <div className="owner-alert owner-alert-error" role="alert">{error}</div>}
        {success && <div className="owner-alert owner-alert-success" role="status">{success}</div>}

        <form className="owner-form owner-form-grid" onSubmit={handleSubmit} noValidate>
          <label>
            <span>{t('ownerRegister.username')} *</span>
            <input value={form.username} onChange={(e) => setField('username', e.target.value)} autoComplete="username" required />
          </label>
          <label>
            <span>{t('ownerRegister.password')} *</span>
            <input type="password" value={form.password} onChange={(e) => setField('password', e.target.value)} autoComplete="new-password" required />
          </label>
          <label>
            <span>{t('ownerRegister.fullName')} *</span>
            <input value={form.name} onChange={(e) => setField('name', e.target.value)} autoComplete="name" required />
          </label>
          <label>
            <span>{t('ownerRegister.email')} *</span>
            <input type="email" value={form.email} onChange={(e) => setField('email', e.target.value)} autoComplete="email" required />
          </label>
          <label>
            <span>{t('ownerRegister.phone')}</span>
            <input value={form.phone} onChange={(e) => setField('phone', e.target.value)} autoComplete="tel" />
          </label>
          <label>
            <span>{t('ownerRegister.registration')} *</span>
            <input value={form.aircraft_registration} onChange={(e) => setField('aircraft_registration', e.target.value)} placeholder="HA-ABC" required />
          </label>
          <label>
            <span>{t('ownerRegister.aircraftType')} *</span>
            <input value={form.aircraft_type} onChange={(e) => setField('aircraft_type', e.target.value)} placeholder="Cessna 172" required />
          </label>
          <label>
            <span>{t('ownerRegister.baseAirport')} *</span>
            <input value={form.base_airport} onChange={(e) => setField('base_airport', e.target.value)} placeholder="LHBS" required />
          </label>
          <button className="btn btn-primary owner-full" type="submit" disabled={saving}>
            {saving ? t('ownerRegister.submitting') : t('ownerRegister.submit')}
          </button>
        </form>

        <p className="owner-login-footnote">
          {t('ownerRegister.hasAccount')} <Link to="/owner/login">{t('ownerRegister.login')}</Link>
        </p>
      </section>
    </div>
  );
}
